import setup from "./setup";
setup();

import makeChart from "./county-map-wage";
let stateTopo = require("../data/usa_states_20m_2017.topo.json");
let countyTopo = require("../data/countyTopo.json");

function main() {

  const theChart = new makeChart({
    element: document.querySelector(".chart"),
    metric: "rentShare",
    rate: "30",
    stateTopo,
    countyTopo
  });

  window.addEventListener("optimizedResize", () => {
    theChart.update();
  });
}
window.onload = main;
